import React from 'react';
import { useRef, useEffect } from 'react';
import styles from '../css/updatedReports.module.css';

function SparkLine({ data, color }) {
  const canvasRef = useRef(null);
  useEffect(() => {
    drawSparkline(canvasRef.current, data, color);
  }, []);

  //   function drawSparkline(canvas, data, color) {
  //     if (!canvas) return;
  //     const ctx = canvas.getContext('2d');
  //     const width = canvas.width;
  //     const height = canvas.height;
  //     const maxData = Math.max(...data);
  //     const minData = Math.min(...data);
  //     const range = maxData - minData || 1;

  //     const points = data.map((d, i) => [
  //       (i / (data.length - 1)) * width,
  //       height - ((d - minData) / range) * (height - 4) - 2,
  //     ]);
  //     ctx.clearRect(0, 0, width, height);
  //     const grad = ctx.createLinearGradient(0, 0, 0, height);
  //     grad.addColorStop(0, color + '30');
  //     grad.addColorStop(1, color + '00');

  //     ctx.beginPath();
  //     ctx.moveTo(points[0][0], height);
  //     points.forEach((p) => ctx.lineTo(p[0], p[1]));
  //     ctx.lineTo(points[points.length - 1][0], height);
  //     ctx.closePath();
  //     ctx.fillStyle = grad;
  //     ctx.fill();

  //     ctx.beginPath();
  //     ctx.moveTo(points[0][0], points[0][1]);
  //     points.forEach((p) => ctx.lineTo(p[0], p[1]));
  //     ctx.strokeStyle = color;
  //     ctx.lineWidth = 1.5;
  //     ctx.lineJoin = 'round';
  //     ctx.lineCap = 'round';
  //     ctx.stroke();
  //   }
  function drawSparkline(canvas, data, color) {
    const ctx = canvas.getContext('2d');
    const w = canvas.width;
    const h = canvas.height;
    const min = Math.min(...data);
    const max = Math.max(...data);
    const range = max - min || 1;
    const pts = data.map((v, i) => [(i / (data.length - 1)) * w, h - ((v - min) / range) * (h - 4) - 2]);

    ctx.clearRect(0, 0, w, h);

    const grad = ctx.createLinearGradient(0, 0, 0, h);
    grad.addColorStop(0, color + '30');
    grad.addColorStop(1, color + '00');
    ctx.beginPath();
    ctx.moveTo(pts[0][0], h);
    pts.forEach((p) => ctx.lineTo(p[0], p[1]));
    ctx.lineTo(pts[pts.length - 1][0], h);
    ctx.closePath();
    ctx.fillStyle = grad;
    ctx.fill();

    ctx.beginPath();
    ctx.moveTo(pts[0][0], pts[0][1]);
    pts.forEach((p) => ctx.lineTo(p[0], p[1]));
    ctx.strokeStyle = color;
    ctx.lineWidth = 1.5;
    ctx.lineJoin = 'round';
    ctx.stroke();
  }
  return <canvas ref={canvasRef} width={200} height={80} className={styles.miniChart} />;
}

export default SparkLine;
